<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
    </div>

    <div class="pa-2">
      <div class="text-xs-right">
        <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
          <em class="fas fa-file-export" />
          &nbsp; Export&nbsp;
        </v-btn>
        <importxlsx :loading="loading" @onChange="onImportXlsx"></importxlsx>
      </div>
      <v-layout row wrap class="pa-0 ma-0">
        <v-flex xs6>
          <v-pagination
            :total-visible="8"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </v-flex>
        <v-flex xs6>
          <div class="form-control" style="position: relative">
            <input
              @keyup.enter="onsearch"
              class="pr-5"
              type="text"
              v-model="filter.department_store"
            />
            <v-btn
              :loading="loading"
              @click="onsearch"
              style="position: absolute; right: 0px; top: 0px"
              icon
            >
              <v-icon color="primary">search</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.department_store }}</td>
          <td class="py-2">
            <div>
              <img
                @click="showImg(props.item.image_url)"
                style="height: 120px; object-fit: contain"
                contain
                :src="props.item.image_url"
              />
            </div>
          </td>
        </template>
      </v-data-table>
      <div>
        <v-dialog width="600px" v-model="showImage">
          <v-card v-if="showImage">
            <v-img @click="showImage = false" :src="currentImage"></v-img>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import * as XLSX from 'xlsx'

export default {
  components: {
    importxlsx,
    exportxlsx
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      showImage: false,
      currentImage: '',
      filter: {
        department_store: ''
      },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: true,
      exportloading: false,
      items: [],
      headers: [
        { text: 'ห้าง', value: 'department_store' },
        { text: 'รูป', value: 'image_url' }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      this.exportloading = true
      api.getpaymentreceipttemplate_toacrm(data, (err, response) => {
        var exporteddata = response.data
        var json = exporteddata.map((el) => {
          return {
            ห้าง: el.department_store,
            ตัวอย่างใบเสร็จ: el.image_url
          }
        })
        console.log(json)
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportedbranchreceipt' + '.xlsx')
        this.exportloading = false
      })
    },

    showImg(item) {
      this.currentImage = item
      this.showImage = true
    },
    onImportXlsx(val) {
      var data = {
        pageid: this.selectedBot.pageid,
        files: val[0]
      }
      api.importpaymentreceipttemplate_toacrm(data, (err, response) => {
        if (response.responsecode == 200) {
          this.getData()
        }
      })
    },
    onsearch() {
      this.getData()
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        ...(this.filter.department_store ? { department_store: this.filter.department_store } : {}), // filter ชื่อห้าง
        limit: this.limit,
        offset: this.offset
      }
      api.getpaymentreceipttemplate_toacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.items = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/BranchReceipt.vue